import { Vec3 } from "@/src/utils/vector";
import { Phase } from "./Walkthrough";
import { commentary, IWalkthroughArgs, setInitialCamera } from "./WalkthroughTools";

export function walkthrough09_Output(args: IWalkthroughArgs) {
    let { walkthrough: wt, state } = args;

    if (wt.phase !== Phase.Input_Detail_Output) {
        return;
    }

    setInitialCamera(state, new Vec3(-20.203, 0.000, -1642.819), new Vec3(281.600, -7.900, 2.298));

    let c0 = commentary(wt, null, 0)`最后一个 Transformer 模块的输出先经过层归一化，再进行一次不带偏置的线性变换。

这次变换将每列从长度 C 映射到词表大小 nvocab，为词表中的每个词元产生一个分数，称为 _预测分数（logits）_。这些分数尚不是概率；经过 Softmax 后才得到概率分布。

本示例模型已经学习了 A、B、C 的排序任务，因此正确答案通常具有很高的概率。

逐步生成时，使用最后一个输入位置对应的输出概率来选择下一个词元。例如输入六个词元，就使用第六列的概率分布。

一种方法是 _按概率采样_：概率为 0.9 的词元，在大量重复抽样中约有 90% 的机会被选中。也可以直接选择概率最高的词元。

还可以通过 _温度参数_ 调整分布。温度较高，概率分布更平缓，生成更随机；温度较低，概率更集中于高分词元。

具体做法是在 Softmax 之前，将 logits 除以温度。由于指数运算会放大分数差异，让分数更接近就会降低这种放大效果。`;

}
